"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withSSIContent = withSSIContent;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _utils = require("@insided/deprecated-preact-components/settings/common/utils");

var _axios = _interopRequireDefault(require("axios"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function withSSIContent(WrappedComponent, transformHtml) {
  return /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(WithSSIContent, _Component);

    var _super = _createSuper(WithSSIContent);

    function WithSSIContent() {
      var _this$props$initialHt;

      var _this;

      (0, _classCallCheck2.default)(this, WithSSIContent);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "currentRequest", void 0);
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "lastRequestedUrl", void 0);
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
        ssiHtml: (_this$props$initialHt = _this.props.initialHtml) !== null && _this$props$initialHt !== void 0 ? _this$props$initialHt : ''
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setSSIHtml", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var url, ssiHtml, finalHtml;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = _this.props.url;

                if (!(!url || url === _this.lastRequestedUrl)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                _this.cancelCurrentRequest();

                _this.lastRequestedUrl = url;
                _this.currentRequest = _axios.default.CancelToken.source();
                _context.prev = 6;
                _context.next = 9;
                return (0, _utils.fetchServerSideHtml)(url, _this.currentRequest.token);

              case 9:
                ssiHtml = _context.sent;

                // Check if this is still the latest request
                if (url === _this.lastRequestedUrl) {
                  finalHtml = transformHtml ? transformHtml(ssiHtml, _this.props) : ssiHtml;

                  _this.setState({
                    ssiHtml: finalHtml
                  });
                }

                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](6);

                // Only update error state if this is still the latest request and it's not a cancellation
                if (!_axios.default.isCancel(_context.t0) && url === _this.lastRequestedUrl) {
                  _this.setState({
                    ssiHtml: "Error fetching server-side HTML: ".concat(_context.t0)
                  });
                }

              case 16:
                _context.prev = 16;

                if (url === _this.lastRequestedUrl) {
                  _this.currentRequest = undefined;
                  _this.lastRequestedUrl = undefined;
                }

                return _context.finish(16);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 13, 16, 19]]);
      })));
      return _this;
    }

    (0, _createClass2.default)(WithSSIContent, [{
      key: "componentDidMount",
      value: function () {
        var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
          return _regenerator.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (this.state.ssiHtml) {
                    _context2.next = 3;
                    break;
                  }

                  _context2.next = 3;
                  return this.setSSIHtml();

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function componentDidMount() {
          return _componentDidMount.apply(this, arguments);
        }

        return componentDidMount;
      }()
    }, {
      key: "componentDidUpdate",
      value: function () {
        var _componentDidUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(prevProps) {
          return _regenerator.default.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!(prevProps.url !== this.props.url && !this.props.initialHtml)) {
                    _context3.next = 3;
                    break;
                  }

                  _context3.next = 3;
                  return this.setSSIHtml();

                case 3:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function componentDidUpdate(_x) {
          return _componentDidUpdate.apply(this, arguments);
        }

        return componentDidUpdate;
      }()
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.cancelCurrentRequest();
      }
    }, {
      key: "cancelCurrentRequest",
      value: function cancelCurrentRequest() {
        if (this.currentRequest) {
          this.currentRequest.cancel('Operation canceled due to new request.');
          this.currentRequest = undefined;
        }
      }
    }, {
      key: "render",
      value: function render() {
        return (0, _preact.h)(WrappedComponent, (0, _extends2.default)({}, this.props, {
          html: this.state.ssiHtml
        }));
      }
    }]);
    return WithSSIContent;
  }(_preact.Component);
}